import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AccordionModule } from 'primeng/accordion'; // Importing AccordionModule for the accordion functionality
import { OrganizationService } from 'src/app/private/services/organization.services';
import { CreateRoleComponent } from "./create-role/create-role.component";
import { DeleteRoleComponent } from "./delete-role/delete-role.component";

@Component({
  selector: 'app-roles',
  imports: [SharedModule, CreateRoleComponent, DeleteRoleComponent],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss'
})
export class RolesComponent {
  @Input() orgId!: string;
  roles: any[] = [];
  //totalRecords = 0;
  totalRecords: number = 0;

  rows = 100;
  //loading = false;
  loading: boolean = true;


  displayAddModal = false;
  addForm: FormGroup;

  selectedRoles: any[] = [];
  actionItems: any[] = [];              
  searchText: string = '';
  searchAttribute: string = 'name';
  roleDataToEdit: any = null; // To hold the campus data to be edited
  showUpdateRole: boolean = false; // Flag to show the edit campus modal
  showDeleteRole: boolean = false; // Flag to show the delete campus modal

  setRoleData(data: any) {
    this.roleDataToEdit = data;
    console.log("Role Data to Edit:", this.roleDataToEdit);
  }

  campusActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Role',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showUpdateRole = true;
          }
        },
        {
          label: 'Delete Role',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteRole = true;
          }
        }
      ]
    }
  ]

  constructor(
    private orgService: OrganizationService,
    private fb: FormBuilder
  ) {
    this.addForm = this.fb.group({
      organization_id: [this.orgId, Validators.required],
      name: ['', Validators.required],
      address: [''],
      city: [''],
      state: [''],
      country: [''],
      postal_code: [''],
      contact_number: [''],
      email: [''],
      website: [''],
      campus_type: [''],
      status: [''],
      code: ['']
    });
  }

  ngOnInit(): void {
  }


  openAddModal() {
    this.addForm.reset();
    this.addForm.patchValue({ organization_id: this.orgId });
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
    this.addForm.reset();
  }

  saveCampus() {
    if (this.addForm.valid) {
      this.orgService.createCampus(this.addForm.value).subscribe(() => {
        this.loadRoles({ first: 0, rows: this.rows });
        this.closeAddModal();
      });
    }
  }

  openMenu(event: MouseEvent, campus: any) {
    this.selectedRoles = [campus];
    const menu = document.querySelector('p-menu') as any;
    menu?.toggle(event);
  }

  loadRoles(event: any, searchValue?: string, searchAttribute?: string): void {
    this.loading = true;

    const payload = {
      organization_id: this.orgId
    };

    this.orgService.getAllRole(payload).subscribe({
      next: (data) => {
        this.roles = data  // Assuming the response has 'rows' property
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err); // Log the error
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadRoles({ first: 0, rows: this.rows });
  }


  handleSearch() {
    this.loadRoles({ first: 0, rows: this.rows }, this.searchText, this.searchAttribute);
  }
}
